import React, { useState } from "react";
import { IoMdClose } from "react-icons/io";
import { FaEye, FaRegFilePdf } from "react-icons/fa";
import { CiImageOn } from "react-icons/ci";
import { TbFileTypeDocx } from "react-icons/tb";
import { FaFolderOpen } from "react-icons/fa";





const getFileTypeIcon = (filename = "") => {
  const ext = filename.split('.').pop().toLowerCase();
  if (["jpg", "jpeg", "png", "gif"].includes(ext)) return <CiImageOn className="text-green-600" />;
  if (["pdf"].includes(ext)) return <FaRegFilePdf className="text-red-600" />;
  if (["doc", "docx"].includes(ext)) return <TbFileTypeDocx className="text-green-600" />
;
  return <FaFolderOpen className="text-gray-600"/>
;
};

const FilePreviewSwitcher = ({ fileUrl, fileName, onFileChange, setPreviewFile, fileType }) => {
  const [showInput, setShowInput] = useState(false);

  if (showInput || !fileUrl) {
    return (
        <div className="relative">
      <input
        type="file"
        onChange={(e) => {
          setShowInput(false);
          onFileChange(e);
        }}
        accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
      />
      <div className="p-2 border border-gray-200 rounded-lg bg-gray-50 text-center">

                                      <span className="text-sm text-gray-500">
                                        Choose file...
                                      </span>
                                  </div>
                                  </div>
    );
  }

  return (
    <div className="flex items-center justify-between p-2 border border-gray-200 rounded bg-gray-50">
      <div className="flex items-center gap-3">
        <span className="text-xl">{getFileTypeIcon(fileName || fileUrl)}</span>
        <span className="text-sm text-gray-800 truncate max-w-[200px]">
          {fileName || fileUrl?.split("/").pop() || "Unnamed File"}
        </span>
        
      </div>
      <button
          type="button"
          className="text-gray-600 hover:text-gray-800 text-lg ml-auto mr-1"
          title="Preview"
          onClick={()=> setPreviewFile({ fileUrl, fileName, fileType })}
        >
          <FaEye />
        </button>
      <button
        type="button"
        onClick={() => setShowInput(true)}
        className="text-red-500 hover:text-red-700 text-lg font-bold"
        title="Remove"
      >
        <IoMdClose />
      </button>
    </div>
  );
};

export default FilePreviewSwitcher;
